import ApiServer from "../ApiServer.ts";
import {SyncCache,ListCache, BaseCache} from "../lib/SyncCache.ts"
import * as DateUtils from "../lib/DateUtils.ts"
import * as amplify from "../util/amplify.ts";
import * as FwDatas from "../FwDatas.ts";

export {PlanningDay,apiCustommplist,getWeekRange}


//dates are 'YYYY-MM-DD' strings, subtracting them gives NaN which makes sort() a no-op
function compareDate(a :string, b :string){
  return a<b?-1:a>b?1:0;
}
export const
  recipeSyncCache = new SyncCache<ApiServer.types.RecipeBean>(ApiServer.metasync.prepare("recipe")),
  recipeCategoriesSyncCache =  new ListCache(ApiServer.metalist.prepare("category"),function(a,b){return a.sortingIndex-b.sortingIndex}),
  dishSyncCache =  new SyncCache<ApiServer.types.DishBean>(ApiServer.metasync.prepare("dish"),function(a,b){return compareDate(a.date,b.date)||a.sortingIndex-b.sortingIndex}),
  mealSyncCache =  new SyncCache<ApiServer.types.MealBean>(ApiServer.metasync.prepare("meal"),function(a,b){return compareDate(a.date,b.date)}),
  MealplannerSettingsCache = new BaseCache<ApiServer.types.MealSettingsBean>(ApiServer.mpsettingsget);

export async function updateMealplannerSettings(settings){
  ApiServer.mpsettingsset(settings)
  await MealplannerSettingsCache.refresh();
}

amplify.subscribe("recipeNeedRefresh",async function(){

  var [recipeList,dishList,recipeCategoriesList] = await Promise.all([
    recipeSyncCache.refresh(),
    dishSyncCache.refresh(),
    recipeCategoriesSyncCache.refresh()
  ]);
  amplify.publish("recipeRefreshed",recipeList,dishList,recipeCategoriesList)

});

class PlanningSlot{
  date : Date;
  column : string;
  dishes : ApiServer.types.DishBean[];
  meal : ApiServer.types.MealBean;

  constructor(date :Date,column :string){
    this.date = date;
    this.column = column
    this.dishes = []
  }
  push(dish){
    this.dishes.push(dish)
  }
  removeMetaId(metaId :string){
    var idx = this.dishes.findIndex(dish=>dish.metaId===metaId);
    return (this.dishes.splice(idx,1)[0]);
  }
}
class PlanningDay{
  date :Date;
  dayNumber : number;
  dayName :string;
  fulldayName :string;
  key :string;
  isToday :boolean;
  visible :boolean;
  dishByType : {[key:string]:PlanningSlot}
  dishes : ApiServer.types.DishBean[]
  events :any[]
  constructor(date :Date, settings :ApiServer.types.MealSettingsBean){
    this.date = date;
    this.key = DateUtils.forInputDate(date);
    this.isToday = DateUtils.isSameDay(new Date(),date);

    this.visible = settings.showWeekEnd|| (date.getDay()!==0 && date.getDay()!==6);

    this.dishByType = {};
    this.dishes = [];

    for(let i=0;i<settings.visibleColumns.length;i++){
      let
        column = settings.visibleColumns[i];
      this.dishByType[column.type] = new PlanningSlot(date,column);
    }
    this.dayNumber = date.getDate()
    this.dayName = DateUtils.toLocaleString(date,{weekday: 'short'}).substring(0,3)

    this.fulldayName = DateUtils.toLocaleString(date,{weekday: 'long', month: 'short', day: 'numeric' }).replace(/^.{1}/,function(firstChar){return firstChar.toUpperCase()})

    this.events = [];
  }
}

function getWeekRange(date :Date){
  return DateUtils.getWeekRange(date,FwDatas.getSettingsPerFamily().mealplannerFirstDayOfWeek)
}
async function apiCustommplist(range){

  var
    [settings,dishList,mealList] = await Promise.all([MealplannerSettingsCache.need(),dishSyncCache.need(),mealSyncCache.need()]),
    from = DateUtils.forInputDate(range.start),
    to =  DateUtils.forInputDate(range.end),
    filtered = dishList.filter(dish=>dish.date>=from && dish.date<to),
    days = [],
    daysByKey = {};

  //build all days in the range
  for(var i=new Date(range.start.getTime());i<range.end;i.setDate(i.getDate()+1)){
    var planningDay = new PlanningDay(new Date(i.getTime()),settings);
    mealList.forEach(meal=>{
      if(meal.note===undefined && meal.serves===null) return;
      if(meal.date===planningDay.key){
        planningDay.dishByType[meal.type].meal = meal;
      }
    })
    days.push(planningDay);
    daysByKey[planningDay.key] = planningDay;
  }
  //fill all days in the range
  filtered = filtered.filter(dish=>{
    var day = daysByKey[dish.date]
    if(day){
      var slot = day.dishByType[dish.type];

      if(slot && slot.column.display){
        day.dishes.push(dish)
        slot.push(dish)
        return true;
      }
    }
  })

  return ({
    list:filtered,
    from,
    to,
    days,
    daysByKey
  })

}